module.exports = __webpack_public_path__ + "media/images/favicons/google-48x48-97dcc67b00ad0d424393a0ceb1bd0d4e.png";